<template>
  <div
    class="m-card"
    :class="{ 'is-muted': muted }"
    role="button"
    tabindex="0"
    @click="onClick"
    @keydown.enter="$emit('open')"
  >
    <div class="m-card__head">
      <div class="m-card__title"><slot name="title" /></div>
      <button
        v-if="showMore"
        type="button"
        class="m-card__more"
        :aria-label="moreLabel"
        @click.stop="$emit('more')"
      >
        <i class="fas fa-ellipsis-v" aria-hidden="true"></i>
      </button>
    </div>
    <div v-if="$slots.badges" class="m-card__badges"><slot name="badges" /></div>
    <div v-if="$slots.default" class="m-card__lines"><slot /></div>
  </div>
</template>

<script>
/**
 * Tarjeta de un registro en listados mobile: título, etiquetas de estado y unas líneas de
 * datos. Tocarla emite «open»; los links y botones de adentro funcionan solos (no abren).
 */
export default {
  name: "MobileRecordCard",
  props: {
    showMore: { type: Boolean, default: true },
    moreLabel: { type: String, default: "Actions" },
    muted: { type: Boolean, default: false },
  },
  methods: {
    onClick(e) {
      if (e.target.closest("a, button, input, select, textarea, label")) return;
      this.$emit("open");
    },
  },
};
</script>

<style scoped>
.m-card {
  margin-bottom: 0.6rem;
  padding: 0.7rem 0.4rem 0.7rem 0.85rem;
  background: var(--m-surface);
  border: 1px solid var(--m-border);
  border-radius: var(--bs-border-radius-lg);
  color: var(--m-text);
  cursor: pointer;
}
.m-card:active {
  background: var(--m-surface-2);
}
.m-card.is-muted {
  opacity: 0.6;
}
.m-card__head {
  display: flex;
  align-items: flex-start;
  gap: 0.25rem;
}
.m-card__title {
  flex: 1;
  min-width: 0;
  font-weight: 600;
  font-size: 1rem;
  line-height: 1.35;
  word-break: break-word;
}
.m-card__more {
  flex-shrink: 0;
  width: 2.25rem;
  height: 2.25rem;
  margin: -0.4rem 0 -0.4rem 0;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: var(--m-muted);
}
.m-card__more:active {
  background: var(--m-pressed);
}
.m-card__badges {
  display: flex;
  flex-wrap: wrap;
  gap: 0.3rem;
  margin-top: 0.4rem;
  padding-right: 0.45rem;
}
/* Etiquetas en un renglón: un valor de lista largo se corta con «…». */
.m-card__badges > * {
  min-width: 0;
  max-width: 100%;
}
/* FieldRenderer deja que la etiqueta haga salto de línea: acá va en uno solo. */
.m-card__badges ::v-deep .badge {
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap !important;
  vertical-align: middle;
}
.m-card__lines {
  margin-top: 0.35rem;
  padding-right: 0.45rem;
  font-size: 0.88rem;
  color: var(--m-muted);
}
</style>
